export const ERRORS_TYPES = {
  PERMISSION: 'errorPermission',
  USED: 'errorCameraUsed',
  LENGTH: 'errorDeviceLength',
  SIZE: 'errorResolution',
};
